var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 6.66927H11.1663V5.0026C11.1663 2.7026 9.29967 0.835938 6.99967 0.835938C4.69967 0.835938 2.83301 2.7026 2.83301 5.0026V6.66927H1.99967C1.08301 6.66927 0.333008 7.41927 0.333008 8.33594V16.6693C0.333008 17.5859 1.08301 18.3359 1.99967 18.3359H11.9997C12.9163 18.3359 13.6663 17.5859 13.6663 16.6693V8.33594C13.6663 7.41927 12.9163 6.66927 11.9997 6.66927ZM4.49967 5.0026C4.49967 3.61927 5.61634 2.5026 6.99967 2.5026C8.38301 2.5026 9.49967 3.61927 9.49967 5.0026V6.66927H4.49967V5.0026ZM11.9997 16.6693H1.99967V8.33594H11.9997V16.6693ZM6.99967 14.1693C7.91634 14.1693 8.66634 13.4193 8.66634 12.5026C8.66634 11.5859 7.91634 10.8359 6.99967 10.8359C6.08301 10.8359 5.33301 11.5859 5.33301 12.5026C5.33301 13.4193 6.08301 14.1693 6.99967 14.1693Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLook);
export default __webpack_public_path__ + "static/media/look.cd47f0bf28a1a425b67bc0ee127ab751.svg";
export { ForwardRef as ReactComponent };